"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faCube = void 0;
var faCube = {
  prefix: 'fal',
  iconName: 'faCube',
  icon: [512, 512, [], '', 'M491.2 85.31l-212.8-81.17C271.2 1.383 263.6 0 256 0S240.8 1.383 233.5 4.145l-212.8 81.17C8.273 90.08 0 102.2 0 115.8v280.4c0 13.57 8.273 25.72 20.76 30.48l212.8 81.17C240.8 510.6 248.4 512 256 512s15.23-1.383 22.47-4.145l212.8-81.17C503.7 421.9 512 409.8 512 396.2V115.8C512 102.2 503.7 90.08 491.2 85.31zM244.9 34.04C248.5 32.69 252.2 32 256 32s7.514 .6875 11.07 2.043l198.9 76.35L256 190.9L45.44 110.1L244.9 34.04zM32 396.2l.1562-256.9L240 219v257.1L32 396.2zM272 476.1V219l207.1-79.73l-.1562 257.5L272 476.1z']
};
exports.faCube = faCube;